<template>
<div class="phone-forget">
    <div class="phone-inner" v-if="wayType==='phone'">
        <div class="return" @click="selectWay('phone')"></div>
        <div class="fonts title">{{ $t($loginLangPrefix('userSign.forget2')) }}</div>

        <div v-show="!verificated">
            <div class="fonts intro">{{ $t($loginLangPrefix('userSign.phoneResetTip')) }}</div>
            <verificate-input :type="3" :name="loginName" :itc="itc" :imgCode="imgCode" @changeCodeError="changeCodeErrorHandle" @changeCode="changeCodeHandle" @changeImgCodeError="changeImgCodeErrorHandle" @changeImgCodeValue="changeImgCodeValueHandle" />
            <error-tip :txt="codeError"/>
            <!-- codeimg -->
            <code-input ref="imgcodeinput" reg="reg" type="phone" :name="loginName" @changeCode="changeImgCodeHandle" @changeCodeError="changeImgCodeErrorHandle" />
            <error-tip :txt="imgCodeError" />
            <!-- codeimg -->
            <div class="fonts send" :class="{has: code && !codeError, cover: cover}" @click="verificateCode()" >{{ $t($loginLangPrefix('userSign.next')) }}</div>
        </div>
        <div v-show="verificated">
            <div class="fonts intro">{{ $t($loginLangPrefix('userSign.newpwTip')) }}</div>
            <password-input @changePassword="changePasswordHandle" @changePasswordError="changePasswordErrorHandle" />
            <error-tip :txt="passwordError"/>
            <div class="fonts send" :class="{has: password && !passwordError, cover: cover}" @click="send()" >{{ $t($loginLangPrefix('userSign.confirmreset')) }}</div>
        </div>

        <p class="fonts inphone" @click="selectWay('email')" >{{ $t($loginLangPrefix('userSign.emailType')) }}</p>
    </div>

    <div class="mphone-inner" v-if="wayType==='m-phone'">
        <!-- <div class="return" @click="selectWay('phone')"></div> -->
        <div class="fonts title mb">{{ $t($loginLangPrefix('userSign.forget2')) }}</div>
        <div v-show="!verificated">
            <div class="fonts intro mb">{{ $t($loginLangPrefix('userSign.phoneResetTip')) }}</div>
            <verificate-input :type="3" mb="mb" :name="loginName" :itc="itc" :imgCode="imgCode" @changeCodeError="changeCodeErrorHandle" @changeCode="changeCodeHandle" @changeImgCodeError="changeImgCodeErrorHandle" @changeImgCodeValue="changeImgCodeValueHandle" />
            <error-tip :txt="codeError" mb="mb" />
            <!-- codeimg -->
            <code-input ref="imgcodeinput" mb="mb" reg="reg" type="phone" :name="loginName" @changeCode="changeImgCodeHandle" @changeCodeError="changeImgCodeErrorHandle" />
            <error-tip mb="mb" :txt="imgCodeError" />
            <!-- codeimg -->
            <div class="fonts send mb" :class="{has: code && !codeError, cover: cover}" @click="verificateCode()" >{{ $t($loginLangPrefix('userSign.next')) }}</div>
        </div>
        <div v-show="verificated">
            <div class="fonts intro mb">{{ $t($loginLangPrefix('userSign.newpwTip')) }}</div>
            <password-input mb="mb" @changePassword="changePasswordHandle" @changePasswordError="changePasswordErrorHandle" />
            <error-tip :txt="passwordError" mb="mb" />
            <div class="fonts send mb" :class="{has: password && !passwordError, cover: cover}" @click="send()" >{{ $t($loginLangPrefix('userSign.confirmreset')) }}</div>
        </div>

        <p class="fonts inphone mb" @click="selectWay('m-email')" >{{ $t($loginLangPrefix('userSign.emailType')) }}</p>
    </div>

    <toast-pop v-show="toastState" :txt="txt"/>
</div>
</template>
<script>

import util from '@utils/util';
import error from '../common/error';
import api from '../js/api';
import logreg from '../js/logreg';
import toast from '../common/toast';
import passwordInput from '../common/password';
import verificateInput from '../common/verificate';
import codeInput from '../common/code';

export default {
    name: 'phoneForget',
    props: {
        loginName: { type: String, default: '' },
        itc: { type: String, default: '' },
        wayType: { type: String, default: '' }
    },
    data() {
        return {
            password: '',
            code: '',
            phoneCode: '',
            codeError: '',
            passwordError: '',
            token: '',
            count: 60,
            countState: false,
            act: false,
            cover: false,
            verificated: false,
            toastState: false,
            txt: '',
            imgCode: '',
            imgCodeError: ''
        };
    },
    components: {
        'error-tip': error,
        'toast-pop': toast,
        'password-input': passwordInput,
        'verificate-input': verificateInput,
        'code-input': codeInput
    },
    methods: {
        changeImgCodeHandle(code) {
            this.imgCode = code;
        },
        changeImgCodeErrorHandle(txt) {
            this.imgCodeError = txt;
        },
        changeCodeErrorHandle(txt) {
            this.codeError = txt;
        },
        changeCodeHandle(code) {
            this.code = code;
        },
        changePasswordHandle(password) {
            this.password = password;
        },
        changePasswordErrorHandle(txt) {
            this.passwordError = txt;
        },
        changeImgCodeValueHandle() {
            this.$refs.imgcodeinput.getVerify();
        },
        selectWay(type) {
            this.$emit('selectWay', type);
        },
        verificateCode() {
            if (this.code && !this.codeError && !this.cover) {
                this.cover = true;
                api.checkFgtCode(this.loginName, this.code).then((data) => {
                    this.cover = false;
                    if (data.ret === '1') {
                    // 验证码发送成功
                        this.verificated = true;
                        this.token = data.access_token;
                    } else {
                        this.codeError = this.$t(this.$loginLangPrefix('userSign.codeError'));
                    }
                }).catch((response) => {
                    this.cover = false;
                    if (response.errorMessageTMXTip) {
                        return;
                    }
                    this.codeError = this.$t(this.$loginLangPrefix('userSign.sysError'));
                });
            }
        },
        send() {
            // this.token accessToken, pwd
            if (this.password && !this.passwordError && !this.cover) {
                this.cover = true;
                const loading = util.loadingFunc();
                api.resetPwd(this.token, this.password).then((data) => {
                    if (data.ret === '1') {
                    // 验证码发送成功
                        logreg.userInfo(this.token, logreg.REGTYPE.phone, 0, (state, udata) => {
                            this.cover = false;
                            try {
                                loading.hide();
                            } catch (e) {
                                console.log(e);
                            }
                            if (state === 'success') {
                                this.$emit('success', udata);
                            } else if ((window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(`${udata.status}`) >= 0) || (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(udata.data && `${udata.data.status}`) >= 0)) {
                                // this.showPop(this.$t(this.$loginLangPrefix('userSign.fkError')));
                            } else if (data.errorMessageTMXTip) {
                                //
                            } else {
                                // 重置失败
                                this.showPop(this.$t(this.$loginLangPrefix('userSign.sysError')));
                            }
                        }, this.loginName);
                    } else {
                        this.cover = false;
                        try {
                            loading.hide();
                        } catch (e) {
                            console.log(e);
                        }
                        // 重置失败
                        this.showPop(this.$t(this.$loginLangPrefix('userSign.sysError')));
                    }
                }).catch((response) => {
                    this.cover = false;
                    try {
                        loading.hide();
                    } catch (e) {
                        console.log(e);
                    }
                    // 重置失败
                    if (response.errorMessageTMXTip) {
                        return;
                    }
                    this.showPop(this.$t(this.$loginLangPrefix('userSign.sysError')));
                });
            }
        },
        showPop(txt, callback) {
            this.txt = txt;
            this.toastState = true;
            setTimeout(() => {
                this.txt = '';
                this.toastState = false;
                callback && callback();
            }, 1500);
        }
    },

    beforeMount() {
        const reg = new RegExp(this.itc, 'i');
        this.phoneCode = this.loginName.replace(reg, '');
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.phone-forget {
    input {
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        outline: none;
        border: 0;
    }
    position: relative;
    width: 100%;
    .return {
        position: relative;
        width: 32px;
        height: 32px;
        top: 0;
        left: 0;
        background-image: url('../images/return.png');
        background-repeat: no-repeat;
        background-size: 32px 32px;
        background-position: center center;
        cursor: pointer;
        &.mb {
            width: rem(32);
            height: rem(32);
            background-size: rem(32) rem(32);
        }
    }
    .fonts {
        font-family: 'RobotoRegular';
    }
    .title {
        // width:200px;
        font-weight: normal;
        margin-top: 20px;
        height:33px;
        font-size:24px;
        color:rgba(23,23,23,1);
        line-height:29px;
        &.mb {
            margin-top: rem(78);
            height: rem(33);
            line-height: rem(29);
        }
    }
    .intro {
        margin-top: 8px;
        // height:32px;
        font-size:14px;
        font-weight: normal;
        color:rgba(153,153,153,1);
        line-height:16px;
        &.mb {
            margin-top: rem(8);
            // height: rem(32);
            line-height: rem(16);
        }
    }
    .send {
        margin-top: 50px;
        position: relative;
        margin-top: 40px;
        width:100%;
        height:48px;
        background:rgba(224,224,224,1);
        border-radius:24px;
        font-size:16px;
        font-family: 'RobotoMedium';
        font-weight:600;
        text-align: center;
        color:rgba(171,171,171,1);
        line-height:48px;
        cursor: pointer;
        transition: background linear .1s;
        &.mb {
            margin-top: rem(40);
            height: rem(48);
            border-radius: rem(24);
            line-height: rem(48);
        }
        &.has {
            background-image: linear-gradient(#9d1dff, #9d1dff);
            color:rgba(255,255,255,1);
        }
        &.cover {
            background-blend-mode: multiply;
            background-color: rgba(0, 0, 0, 0.2);
        }
    }
    .inphone {
        margin-top: 10px;
        width: 100%;
        text-align: center;
        font-size:14px;
        font-weight: normal;
        color:rgba(153,153,153,1);
        line-height:14px;
        text-decoration: underline;
        cursor: pointer;
        &.mb {
            margin-top: rem(10);
            line-height: rem(14);
        }
    }
}
</style>
